import Clipboard from 'clipboard';

// Convenience function to set visibility given a boolean argument //////////////////////////

$.fn.setVisibility = function(show) {
  this[show ? 'show' : 'hide']();
};



// Escape regular expression ////////////////////////////////////////////////////////////////

RegExp.escape= function(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};


// Scroll textarea to position //////////////////////////////////////////////////////////////

function scrollTextareaToPosition($textarea, position) {
  var text = $textarea.val();
  var textBeforePosition = text.substr(0, position);
  $textarea.blur();
  $textarea.val(textBeforePosition);
  $textarea.focus();
  $textarea.val(text);
  $textarea.setSelection(position, position); // assumes that you use jquery-fieldselection.js
  $textarea.focus()

}


//// Make AJAX pass Rails XRF protection //////////////////////////////////////////////////////
//
//$(document).ajaxSend(function(e, xhr, options) {
//  var token = $("meta[name='csrf-token']").attr("content");
//  xhr.setRequestHeader("X-CSRF-Token", token);
//});


// Bookmarklet //////////////////////////////////////////////////////////////////////////////

up.compiler('body.bookmarklet', function(body) {
  var $body = $(body)
  $body.find('#head a, #tail a').attr('target', '_blank');
});



// Pane View ///////////////////////////////////////////////////////////////////////////////////////////////////////

up.compiler('[pane-view-sidebar]', function(paneViewSidebar) {
  var $paneViewSidebar = $(paneViewSidebar)

  function setHeight() {
    var clientHeight = document.documentElement.clientHeight;
    var paneViewSidebarTop = $paneViewSidebar.offset().top;
    var paneViewMarginBottom = parseInt($paneViewSidebar.css('marginBottom'));
    $paneViewSidebar.height(clientHeight - paneViewSidebarTop - paneViewMarginBottom);
  }

  // The container size will only be rendered in the next frame
  up.util.task(setHeight);

  $(window).on('resize', setHeight);

  return function() {
    $(window).off('resize', setHeight)
  };

});


// Handle Matomo tracking
///////////////////////////////////////////////////////////////////////////////////
var lastTrackedUrl;
up.compiler('[track_for_analytics]', function(element, data, meta) {
  if (meta.revalidating) return

  if (typeof(_paq) !== "undefined") {
    var trackingUrl = element.getAttribute('track_for_analytics') || up.history.location;
    if ( trackingUrl !== lastTrackedUrl ) {
      // deal with relative and absolute urls
      let anchor = document.createElement('a');
      anchor.href = trackingUrl;
      _paq.push(['setCustomUrl', anchor.href])
      _paq.push(['trackPageView'])
      lastTrackedUrl = trackingUrl;
    }
  }
});


// mobile navigation
//////////////////////////////////////////////////////////////////////////////////
up.compiler('.mobile_navigation_icon', function (element) {
  var $element = $(element)
  if ($element.is(":visible")) {
    var $navigation = $element.siblings('.account_navigation');
    $element.on('click', function (event) {
      $navigation.toggleClass('hidden');
      event.stopPropagation();
    });
    $(window).click(function () {
      if (!$navigation.hasClass('hidden')) {
        $navigation.addClass('hidden');
      }
    });
  }
});

function checkPaneView() {
  var $body = $(document.body);
  var paneView = !!up.fragment.get('.pane_view');
  $body.toggleClass('without_tail', paneView);
}

up.compiler('#notes', function() {
  checkPaneView();
  return checkPaneView;
});

up.compiler('[public_url]', function(element) {
  let publicURL = element.getAttribute('public_url')
  let anchor = window.location.href.split(/(?=#)/g)[1]
  if (anchor) { publicURL += anchor }
  up.history.replace(publicURL);
});

up.compiler('.clippy', function(trigger, data) {
  var clipboard = new Clipboard(trigger, {
    text: function(trigger) {
      return data['text'];
    }
  });

  return function() {
    clipboard.destroy();
  };

});
